import LayoutCredit from './LayoutCredit';

export default LayoutCredit;
